var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOctopus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2146_13207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1818 23.1813C22.7727 23.1813 22.5 23.454 22.5 23.8631C22.5 24.6131 21.8863 25.2267 21.1363 25.2267C20.3863 25.2267 19.7727 24.6131 19.7727 23.8631V17.7267C19.7727 17.3176 19.5 17.0449 19.0909 17.0449C18.6818 17.0449 18.4091 17.3176 18.4091 17.7267V23.8631C18.4091 25.3631 19.6363 26.5904 21.1363 26.5904C22.6363 26.5904 23.8636 25.3631 23.8636 23.8631C23.8636 23.454 23.5909 23.1813 23.1818 23.1813Z",
    fill: "url(#paint0_linear_2146_13207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.409 28.6364C17.659 28.6364 17.0454 28.0227 17.0454 27.2727V15.6818C17.0454 15.2727 16.7727 15 16.3636 15C15.9545 15 15.6818 15.2727 15.6818 15.6818V27.2727C15.6818 28.7727 16.909 30 18.409 30C18.8181 30 19.0909 29.7273 19.0909 29.3182C19.0909 28.9091 18.8181 28.6364 18.409 28.6364Z",
    fill: "url(#paint1_linear_2146_13207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3182 21.1358C28.5682 21.1358 27.9546 20.5222 27.9546 19.7722C27.9546 18.2722 26.7273 17.0449 25.2273 17.0449H21.1364C20.7273 17.0449 20.4546 17.3176 20.4546 17.7267C20.4546 18.1358 20.7273 18.4086 21.1364 18.4086H25.2273C25.9773 18.4086 26.591 19.0222 26.591 19.7722C26.591 21.2722 27.8182 22.4995 29.3182 22.4995C29.7273 22.4995 30 22.2267 30 21.8176C30 21.4086 29.7273 21.1358 29.3182 21.1358Z",
    fill: "url(#paint2_linear_2146_13207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5909 17.7267C11.5909 17.3176 11.3182 17.0449 10.9091 17.0449C10.5 17.0449 10.2273 17.3176 10.2273 17.7267V23.8631C10.2273 24.6131 9.61363 25.2267 8.86363 25.2267C8.11363 25.2267 7.49999 24.6131 7.49999 23.8631C7.49999 23.454 7.22726 23.1813 6.81817 23.1813C6.40908 23.1813 6.13635 23.454 6.13635 23.8631C6.13635 25.3631 7.36363 26.5904 8.86363 26.5904C10.3636 26.5904 11.5909 25.3631 11.5909 23.8631V17.7267Z",
    fill: "url(#paint3_linear_2146_13207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6363 15C13.2272 15 12.9545 15.2727 12.9545 15.6818V27.2727C12.9545 28.0227 12.3409 28.6364 11.5909 28.6364C11.1818 28.6364 10.9091 28.9091 10.9091 29.3182C10.9091 29.7273 11.1818 30 11.5909 30C13.0909 30 14.3181 28.7727 14.3181 27.2727V15.6818C14.3181 15.2727 14.0454 15 13.6363 15Z",
    fill: "url(#paint4_linear_2146_13207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1364 8.18164C21.1364 9.818 20.4545 10.8407 19.7727 11.9998C19.5 12.4771 19.2273 12.9544 18.9545 13.4316C18.6818 14.0453 18.6818 14.7953 19.0909 15.4089C19.5 16.0226 20.1136 16.3635 20.7955 16.3635H21.6818C24.0682 16.3635 25.9091 14.5907 25.9091 12.2725V10.2271C25.9091 9.4771 26.5227 8.86346 27.2727 8.86346C28.0227 8.86346 28.6364 9.4771 28.6364 10.2271C28.6364 10.6362 28.9091 10.9089 29.3182 10.9089C29.7273 10.9089 30 10.6362 30 10.2271C30 8.7271 28.7727 7.49982 27.2727 7.49982C25.7727 7.49982 24.5455 8.7271 24.5455 10.2271V12.2725C24.5455 13.7726 23.3182 14.9998 21.6818 14.9998H20.7955C20.5909 14.9998 20.3182 14.8635 20.25 14.6589C20.1136 14.4544 20.1136 14.1816 20.1818 13.9771C20.3864 13.568 20.6591 13.1589 20.9318 12.6816C21.6818 11.4544 22.5 10.1589 22.5 8.11346C22.5 3.27255 19.4318 -0.0683594 15 -0.0683594C10.5682 -0.0683594 7.5 3.34073 7.5 8.18164C7.5 10.1589 8.31818 11.5226 9.06818 12.7498C9.34091 13.1589 9.61364 13.6362 9.81818 14.0453C9.95455 14.2498 9.88636 14.5226 9.75 14.7271C9.61364 14.9316 9.40909 15.068 9.20455 15.068H8.18182C6.68182 15.068 5.45455 13.8407 5.45455 12.3407V10.2953C5.45455 8.79528 4.22727 7.568 2.72727 7.568C1.22727 7.568 0 8.79528 0 10.2953C0 10.7044 0.272727 10.9771 0.681818 10.9771C1.09091 10.9771 1.36364 10.7044 1.36364 10.2953C1.36364 9.54528 1.97727 8.93164 2.72727 8.93164C3.47727 8.93164 4.09091 9.54528 4.09091 10.2953V12.3407C4.09091 14.5907 5.93182 16.4316 8.18182 16.4316H9.20455C9.88636 16.4316 10.5682 16.0907 10.9091 15.4771C11.3182 14.8635 11.3182 14.1135 11.0455 13.4998C10.8409 13.0225 10.5 12.5453 10.2273 12.068C9.54545 10.9089 8.86364 9.818 8.86364 8.24982C8.86364 4.15891 11.3182 1.43164 15 1.43164C18.6818 1.43164 21.1364 4.09073 21.1364 8.18164Z",
    fill: "url(#paint5_linear_2146_13207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2728 12.2738C12.6493 12.2738 12.9546 11.9685 12.9546 11.592C12.9546 11.2154 12.6493 10.9102 12.2728 10.9102C11.8962 10.9102 11.5909 11.2154 11.5909 11.592C11.5909 11.9685 11.8962 12.2738 12.2728 12.2738Z",
    fill: "url(#paint6_linear_2146_13207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7272 12.2738C18.1038 12.2738 18.409 11.9685 18.409 11.592C18.409 11.2154 18.1038 10.9102 17.7272 10.9102C17.3507 10.9102 17.0454 11.2154 17.0454 11.592C17.0454 11.9685 17.3507 12.2738 17.7272 12.2738Z",
    fill: "url(#paint7_linear_2146_13207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54545 17.7267C9.54545 17.3176 9.27273 17.0449 8.86364 17.0449H4.77273C3.27273 17.0449 2.04545 18.2722 2.04545 19.7722C2.04545 20.5222 1.43182 21.1358 0.681818 21.1358C0.272727 21.1358 0 21.4086 0 21.8176C0 22.2267 0.272727 22.4995 0.681818 22.4995C2.18182 22.4995 3.40909 21.2722 3.40909 19.7722C3.40909 19.0222 4.02273 18.4086 4.77273 18.4086H8.86364C9.27273 18.4086 9.54545 18.1358 9.54545 17.7267Z",
    fill: "url(#paint8_linear_2146_13207)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2146_13207",
    x1: 21.1363,
    y1: 17.0449,
    x2: 21.1363,
    y2: 26.5904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2146_13207",
    x1: 17.3863,
    y1: 15,
    x2: 17.3863,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2146_13207",
    x1: 25.2273,
    y1: 17.0449,
    x2: 25.2273,
    y2: 22.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2146_13207",
    x1: 8.86363,
    y1: 17.0449,
    x2: 8.86363,
    y2: 26.5904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2146_13207",
    x1: 12.6136,
    y1: 15,
    x2: 12.6136,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2146_13207",
    x1: 15,
    y1: -0.0683594,
    x2: 15,
    y2: 16.4316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2146_13207",
    x1: 12.2728,
    y1: 10.9102,
    x2: 12.2728,
    y2: 12.2738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2146_13207",
    x1: 17.7272,
    y1: 10.9102,
    x2: 17.7272,
    y2: 12.2738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2146_13207",
    x1: 4.77273,
    y1: 17.0449,
    x2: 4.77273,
    y2: 22.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2146_13207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctopus);
export default __webpack_public_path__ + "static/media/octopus.8fb4a040.svg";
export { ForwardRef as ReactComponent };